import { ExternalLink, MessageCircle, MessageSquarePlus } from "lucide-react";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { SectionShell } from "./SectionShell";

const CONTACT_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfGctjmssSGu73JcGfPeECrLstNGZF5w_36ePFOZLw7s-1HPg/viewform";

/**
 * 見出しを2行に割る。
 * 和文の「お問い合わせ・無料相談」は中黒で折り返すと「お問い合わせ・無／料相談」と
 * 語の途中で切れるので、中黒の位置で改行し中黒自体は出さない（オーナー指示 2026-09-11）。
 * 中黒を含まない言語では1行のまま。
 */
const splitHeading = (value: string) => {
  const parts = value.split("・");
  return parts.map((part, i) => (
    <Fragment key={part}>
      {i > 0 && <br />}
      {part}
    </Fragment>
  ));
};

export const ContactSection = () => {
  const { t } = useTranslation();
  const note = t("contact.form_note");

  return (
    <SectionShell
      id="contact"
      className="contact"
      icon={<MessageCircle aria-hidden="true" focusable="false" />}
      heading={splitHeading(t("contact.heading"))}
    >
      <p data-reveal>{t("contact.subheading")}</p>
      <a className="contact-button" href={CONTACT_FORM_URL} target="_blank" rel="noopener noreferrer">
        <MessageSquarePlus aria-hidden="true" focusable="false" />
        <span>{t("contact.button")}</span>
        <ExternalLink aria-hidden="true" focusable="false" />
      </a>
      <p className="contact-note">{note}</p>
    </SectionShell>
  );
};
